import { create } from 'zustand';
import { EVENTS } from "@smarterservices/media-agent";
export const createCommunicationStore = (initialState = {}) =>
  create((set, get) => ({
    stores: {},
    unseenChatMessageCount: 0, // The number of chat messages that are unseen...
    handRaised: false, // if the student hand is raised

    injectDependentStores: (stores) => {
      set({ stores });
    },

    storeState: (name) => {
      if (!get().stores[name])
        throw new Error(`${name} is not a valid dependency in this store.`);
      return get().stores[name].getState();
    },


    initialize: async () => {
      get().setupCommunicationListeners();
    },

    setupCommunicationListeners: () => {
      if (!get().storeState('appStore').mediaClient) {
        return;
      }

      // setup listeners for communication events...
      const emitter = get().storeState('appStore').mediaClient.getEventEmitter();

      if (emitter) {
        emitter.on(EVENTS.CHAT_MESSAGE_ADDED, ({ payload }) => {
          get().handleChatMessageAdded(payload);
        });
      }
    },

    clearCommunicationListeners: () => {
      if (!get().storeState('appStore').mediaClient) {
        return;
      }

      const emitter = get().storeState('appStore').mediaClient.getEventEmitter();
      if (emitter) {
        emitter.off(EVENTS.CHAT_MESSAGE_ADDED);
      }
    },

    setUnseenChatMessageCount: (value) => {
      set({ unseenChatMessageCount: value || 0 });
      // Trigger the event that there is a new unseen chat message count...
      get().storeState('eventStore').trigger('onUnreadMessageCountChange', { count: value });
    },

    handleChatMessageAdded: (payload) => {
      // Only suppress unread count when the session is actively in focus mode
      // AND the user is viewing the communication tab. Previously, only the tab
      // was checked — but sessionDetailsTab persists as 'communication' even after
      // unfocusing, causing messages to be silently ignored in overview mode.
      const appState = get().storeState('appStore');
      const isViewingChat = appState.viewMode === 'focus' &&
        appState.sessionDetailsTab === 'communication';

      if (!isViewingChat) {
        // Don't count messages from proctors (identity starts with PU)
        if (payload?.identity?.startsWith('PU')) {
          return;
        }
        get().setUnseenChatMessageCount(get().unseenChatMessageCount + 1);
      }
    },

    setHandRaised: (value) => {
      set({ handRaised: value || false });
      get().storeState('eventStore').trigger('onHandRaisedChange', { raised: value || false });
    },



  }));
